<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card :loading="ofertas.loading">
          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="ofertas.headers"
            :items="ofertas.ofertas"
            :items-per-page="10"
            :search="search"
            :sort-by.sync="ofertas.sortBy"
            :sort-desc.sync="ofertas.sortDesc"
            :footer-props="{
              'items-per-page-options': [5, 10, 15, 20, -1],
            }"
            class="elevation-1"
          >
            <template v-slot:item.FechaOferta="{ item }">
              {{ formatarFecha(item.FechaOferta) }}
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="verLineas(item)">
                mdi-eye
              </v-icon>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog">
      <v-card>
        <v-card-title>
          <span class="text-h5">Líneas</span>
        </v-card-title>
        <v-card-text>
          <template>
            <v-data-table
              :headers="lineas.headers"
              :items="lineas.lineas"
              :items-per-page="-1"
              hide-default-footer
              :loading="lineas.loading"
              loading-text="Cargando..."
              class="elevation-1"
            >
              <template v-slot:item.Peso="{ item }">
                {{ redondear(item.Peso, 4) }}
              </template>
              <template v-slot:item.Precio="{ item }">
                {{ redondear(item.Precio, 2) }}
              </template>
              <template v-slot:item.Porcen_Exito_Oferta="{ item }">
                {{ redondear(item.Porcen_Exito_Oferta, 0) + "%" }}
              </template>
            </v-data-table>
          </template>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="cerrar"> Cerrar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <NuevaOferta />
  </v-container>
</template>


<script>
import axios from "axios";
import { mapState, mapActions } from "vuex";
import formatearFecha from "@/mixins/formatearFecha";
import NuevaOferta from "@/components/nuevaOferta/Container.vue";
axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
export default {
  name: "containerOfertasPendientes",
  mixins: [formatearFecha],
  components: {
    NuevaOferta,
  },
  data() {
    return {
      loading: null,
      dialog: "",
      search: "",
      ofertas: {
        headers: [
          { text: "Empresa", value: "empresa.Empresa" },
          { text: "Fecha", value: "FechaOferta" },
          { text: "Serie", value: "SerieOferta" },
          { text: "Número Oferta", value: "NumeroOferta" },
          { text: "Razón Social", value: "RazonSocial" },
          { text: "Observación oferta", value: "ObservacionesOferta" },
          { text: "", value: "actions", sortable: false },
        ],
        ofertas: [],
        loading: null,
        sortBy: "NumeroOferta",
        sortDesc: true,
      },
      lineas: {
        headers: [
          { text: <v-icon>mdi-cart</v-icon>, value: "CodigoArticulo", sortable: false },
          { text: <v-icon>mdi-weight</v-icon>, value: "Peso", sortable: false },
          { text: "Descripción", value: "DescripcionArticulo", sortable: false },
          { text: <v-icon>mdi-currency-eur</v-icon>, value: "Precio", sortable: false },
          { text: "% Éxito", value: "Porcen_Exito_Oferta", sortable: false },
          { text: "Motivo baja", value: "UVE_MotivoBajaOferta", sortable: false },
        ],
        lineas: [],
        loading: null,
      },
    };
  },
  methods: {
    ...mapActions(["setLoading", "setSnackbar"]),
    async verLineas(item) {
      this.setLoading(true);
      this.lineas.lineas = [];
      this.lineas.loading = true;
      try {
        let respuesta = await axios.get(
          `/api/ofertas-pendientes/lineas?id=${item.IdOfertaPro}`
        );
        this.lineas.lineas = respuesta.data;
        this.dialog = true;
      } catch (error) {
        // console.log(error);
        this.setSnackbar({
          snackbar: true,
          tipo: "error",
          mensaje: "Error. No se han podido obtener las líneas de la oferta",
        });
      }
      this.setLoading(false);
      this.lineas.loading = false;
    },
    cerrar() {
      this.dialog = false;
    },
    redondear(numero, decimales) {
      numero = Number(numero).toFixed(decimales).toString().split(".");
      numero[0] = numero[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      return numero.join(",");
    },
  },
  async mounted() {
    this.ofertas.loading = true;
    try {
      let respuesta = await axios.get("/api/ofertas-pendientes");
      this.ofertas.ofertas = respuesta.data;
    } catch (error) {
      // console.log(error);
      this.setSnackbar({
        snackbar: true,
        tipo: "error",
        mensaje: "Error. No se han podido obtener las ofertas pendientes",
      });
    }
    this.ofertas.loading = false;
  },
};
</script>